let Mock=require("mockjs")
Mock.mock("data/aa","get",require("./data/aa.json"))